import { Moment } from "moment";
import { Gig } from "../gig";
import Project_Entity from "./project";
export default class Project extends Project_Entity {
  static fromList(projectsJSON: unknown): Array<Project> {
    const projects: Project[] = [];
    if (projectsJSON)
      Array.isArray(projectsJSON) &&
        projectsJSON.forEach((projectJSON) => {
          projects.push(new Project(projectJSON));
        });
    return projects;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  completedGigCount() {
    let completed = 0;

    this.gigs?.forEach((g) => {
      const gig = new Gig(g);
      if (gig.completed()) completed++;
    });
    return completed;
  }

  sessionTypeDescription() {
    const types: any = {};
    this.gigs?.forEach((g) => {
      const gig = new Gig(g);
      const type = gig.sessionType();
      if (type == null) return;
      if (types[type] != null) {
        types[type] = types[type]! + 1;
      } else {
        types[type] = 1;
      }
    });

    const description = [];
    for (const key in types) {
      if (Object.prototype.hasOwnProperty.call(types, key)) {
        const qty = types[key];
        description.push(`${qty} ${key}${qty > 1 ? "s" : ""}`);
      }
    }

    if (description.length == 0) return "0 Services";

    return description.join(", ");
  }

  gigCount() {
    return this.gigs?.length ?? 0;
  }

  completed() {
    return this.gigCount() == this.completedGigCount();
  }

  completion() {
    if (this.gigCount() != 0) {
      return (this.completedGigCount() / this.gigCount()) * 100;
    }
    return 0;
  }

  from() {
    let min: Moment;

    try {
      if (this.gigs.length) min = new Gig(this.gigs[0]).from();
    } catch (e) {
      console.log(e);
    }

    this.gigs?.forEach((g) => {
      const gig = new Gig(g);
      if (gig.from().isBefore(min)) {
        min = gig.from();
      }
    });

    return min;
  }

  to() {
    let max: Moment;

    try {
      if (this.gigs.length) max = new Gig(this.gigs[0]).to();
    } catch (e) {
      console.log(e);
    }

    this.gigs?.forEach((g) => {
      const gig = new Gig(g);
      if (gig.to().isAfter(max)) {
        max = gig.to();
      }
    });

    return max;
  }

  dateDescription() {
    const from = this.from();
    const to = this.to();

    const fromFormat = from != null ? from.format("M/D/yyy") : "";
    const toFormat = to != null ? to.format("M/D/yyy") : "";

    if (fromFormat == toFormat) return fromFormat;

    if (from != null && to != null) {
      return `From ${fromFormat} to ${toFormat}`;
    }

    return "Unknown dates";
  }

  inject({ gigs }: { gigs: Gig[] }) {
    const _gigs = gigs?.filter((g) => g.projectID == this.sourceRecordID) ?? [];

    this.gigs = [];
    _gigs.forEach((p) => {
      this.gigs.push(p);
    });

    return this;
  }
}
